module.exports = __webpack_public_path__ + "static/media/efficiency.4cdfc941.svg";